var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWindowTint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "window-tint"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.6068 7.92738C21.612 7.92738 22.4268 7.11253 22.4268 6.10737C22.4268 5.1022 21.612 4.28735 20.6068 4.28735C19.6016 4.28735 18.7868 5.1022 18.7868 6.10737C18.7868 7.11253 19.6016 7.92738 20.6068 7.92738Z",
    fill: "#D1D1D5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M30.545 11.9266C31.5501 11.9266 32.365 11.1118 32.365 10.1066C32.365 9.10147 31.5501 8.28662 30.545 8.28662C29.5398 8.28662 28.7249 9.10147 28.7249 10.1066C28.7249 11.1118 29.5398 11.9266 30.545 11.9266Z",
    fill: "#D1D1D5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M34.7456 21.781C35.7507 21.781 36.5656 20.9662 36.5656 19.961C36.5656 18.9558 35.7507 18.141 34.7456 18.141C33.7404 18.141 32.9256 18.9558 32.9256 19.961C32.9256 20.9662 33.7404 21.781 34.7456 21.781Z",
    fill: "#D1D1D5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M30.7467 31.7207C31.7519 31.7207 32.5668 30.9059 32.5668 29.9007C32.5668 28.8955 31.7519 28.0807 30.7467 28.0807C29.7416 28.0807 28.9267 28.8955 28.9267 29.9007C28.9267 30.9059 29.7416 31.7207 30.7467 31.7207Z",
    fill: "#D1D1D5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M20.8917 35.9208C21.8969 35.9208 22.7117 35.1059 22.7117 34.1008C22.7117 33.0956 21.8969 32.2808 20.8917 32.2808C19.8865 32.2808 19.0717 33.0956 19.0717 34.1008C19.0717 35.1059 19.8865 35.9208 20.8917 35.9208Z",
    fill: "#D1D1D5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M10.9526 31.9219C11.9578 31.9219 12.7727 31.107 12.7727 30.1019C12.7727 29.0967 11.9578 28.2819 10.9526 28.2819C9.94748 28.2819 9.13263 29.0967 9.13263 30.1019C9.13263 31.107 9.94748 31.9219 10.9526 31.9219Z",
    fill: "#D1D1D5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M6.75239 22.0669C7.75755 22.0669 8.5724 21.2521 8.5724 20.2469C8.5724 19.2417 7.75755 18.4269 6.75239 18.4269C5.74722 18.4269 4.93237 19.2417 4.93237 20.2469C4.93237 21.2521 5.74722 22.0669 6.75239 22.0669Z",
    fill: "#D1D1D5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M10.7508 12.1281C11.756 12.1281 12.5708 11.3132 12.5708 10.3081C12.5708 9.30289 11.756 8.48804 10.7508 8.48804C9.74566 8.48804 8.93082 9.30289 8.93082 10.3081C8.93082 11.3132 9.74566 12.1281 10.7508 12.1281Z",
    fill: "#D1D1D5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M28.1728 13.7188C26.3904 11.6079 23.728 10.2642 20.749 10.2642C15.3828 10.2642 11.0326 14.6143 11.0326 19.9806C11.0326 20.3421 11.0557 20.6979 11.0942 21.0492L28.1728 13.7188Z",
    fill: "#D1D1D5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M13.5241 26.4611C15.3029 28.4429 17.8763 29.6969 20.749 29.6969C26.1152 29.6969 30.4654 25.3467 30.4654 19.9805C30.4654 19.7191 30.4466 19.4625 30.4263 19.2063L13.5241 26.4611Z",
    fill: "#D1D1D5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M5.91665 27.663C5.53533 27.663 5.17187 27.441 5.00969 27.0693C4.792 26.5683 5.02127 25.9862 5.52181 25.768L35.1996 12.8538C35.7015 12.6337 36.2837 12.8659 36.5009 13.366C36.719 13.8665 36.4893 14.4491 35.9892 14.6668L6.31052 27.581C6.18212 27.637 6.04842 27.663 5.91665 27.663Z",
    fill: "#898B94"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowTint);
export default __webpack_public_path__ + "static/media/window-tint.7b2fecce07eeaa8c4f1fec2f16f038c3.svg";
export { ForwardRef as ReactComponent };